module.exports = __webpack_public_path__ + "img/tradition1.f8b096d6.png";